import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CreateOrUpdateSecureMessageDto, MessageRequestDto,MemberMessageResponseDto, FilterDto, SecureMessageListingDto, MessageConversionListingDto, UpdateMemberReadDateDto } from '@shared/models/message.model';
import { Observable } from 'rxjs';
import { AppConfig } from '@shared/models/app-config.model';
import { Constants } from '@shared/services/constants';
import { Constant } from '@shared/utilities/constant';
import { MemberTask } from '@shared/models/member-task.model';
import { HttpUtility } from '@app/core/utilities/http.utility';

@Injectable()
export class MemberTaskService {
    constructor(private http: HttpUtility, 
        @Inject(Constant.appConfig) private appConfig: AppConfig,
        ) { }
  
    private headers: HttpHeaders;

  
    

    public updateMemberTaskStatus(memberTask: MemberTask): Observable<any> {
        let url = `${this.appConfig.apiBaseUrl}${Constants.updateMemberTask}`;
        var memberTaskUrl = url.replace(/##memberId##/g, memberTask.memberID).replace(/##taskId##/g,memberTask.id);
        console.log(memberTaskUrl);
        return this.http.postByOptions(memberTaskUrl, null, {headers: this.headers});
    }

    }
